import { render, staticRenderFns } from "./icon-share.vue?vue&type=template&id=6690bcfa"
import script from "./icon-share.vue?vue&type=script&lang=ts"
export * from "./icon-share.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports